
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"34","viewBox":"0 0 34 34","fill":"#fff","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.1 13.1a9.75 9.75 0 019.8-9.8c5.46 0 9.8 4.455 9.8 9.8 0 1.758-.437 3.304-1.192 4.723l-.18.448c-.05.126-.125.24-.22.336l-.02.02-7.24 11.602a1 1 0 01-1.693.006l-7.36-11.636a1.514 1.514 0 01-.176-.274.985.985 0 01-.051-.07l-.2-.3a.971.971 0 01-.049-.08C7.548 16.44 7.1 14.88 7.1 13.1zm1.498 5.182l.002.004-.002-.004zM16.9 5.3a7.75 7.75 0 00-7.8 7.8c0 1.404.344 2.63.959 3.786l.135.203c.099.119.158.229.186.286.024.029.045.06.065.09l6.55 10.355 6.457-10.35a.995.995 0 01.093-.126l.127-.315a.99.99 0 01.047-.103c.629-1.167.981-2.405.981-3.826 0-4.255-3.46-7.8-7.8-7.8zm-6.498 12.118l-.002-.004.002.004z"}}),_c('path',{attrs:{"d":"M17 15.9a3.4 3.4 0 100-6.8 3.4 3.4 0 000 6.8z"}})])
          )
        }
      }
    